module.exports = __webpack_public_path__ + "static/media/default-photo.9e6b3f39.png";